import ExportFileMixin from "../../../mixins/export-file";

Vue.component("asset-groups", {
    mixins: [require("../../../mixins/vuetable-css-mixin"), ExportFileMixin],

    created () {
        let self = this;
        Bus.$on("asset-group-created", function () {
            self.hideAssetGroupCreateForm();
            Vue.nextTick(() => self.$refs.vuetable.refresh());
        });
    },

    data () {
        return {
            searchParams: {
                filter_text: "",
                archived_filter: false,
            },
            columns: [
                {
                    name: "__slot:name",
                    title: "Name",
                    sortField: "name",
                    dataClass: "text-nowrap"
                },
                {
                    name: "type",
                    sortField: "type",
                    dataClass: "text-nowrap"
                },
                {
                    name: "full_address",
                    title: "Full Address"
                },
                {
                    name: "__slot:view_asset_group",
                    title: "",
                    titleClass: "center aligned",
                    dataClass: "text-right"
                }
            ]
        };
    },

    methods: {
        showAssetGroupCreateForm () {
            if (!this.verifyTeamIsSubscribed()) {
                return;
            }

            $("#modal-asset-group-form").modal("show");
        },

        hideAssetGroupCreateForm () {
            $("#modal-asset-group-form").modal("hide");
        },

        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },

        onActionClick (action, data, index) {
            switch (action) {
                case "view-item":
                    window.location = "/assets/groups/" + data.id;
                    break;
            }
        },

        onChangePage (page) {
            this.$refs.vuetable.changePage(page);
        },

        doFilter () {
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },

        toggleArchivedAssetGroups () {
            this.$set(this.searchParams, "archived_filter", !this.searchParams.archived_filter);
            this.doFilter();
        },

        exportAssetGroups () {
            this.$set(this.searchParams, "sort",  this.$refs.vuetable?.getSortParam());
            this.exportData("/assets/groups/export", this.searchParams, this.$dayjs().format("DD-MM-YYYY") + " Asset Groups Export.xlsx");
        },
    },
});
